module.exports = __webpack_public_path__ + "static/media/Slice23@2x.835af099.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice23@2x.png
// module id = 1451
// module chunks = 0